import { Nav } from "./routes";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en, fr } from "./i18n";
import { getSystemLanguage } from "./utils";
import { makeStyles } from "@mui/styles";
import { ThemeProvider } from "@mui/material";
import { theme } from "./config";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GlobalProvider } from "./context/globalContext";

const useStyles = makeStyles(theme => ({
  fullScreen: {
    width: "100%",
    //minheight: "100vh",
    overflow: "hidden",
    backgroundImage: "url(./assets/background_large.png)",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
}));

const App = () => {
  const classes = useStyles();

  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: { en, fr },
      lng: getSystemLanguage(),
      fallbackLng: "en",
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    });
  const queryClient = new QueryClient({ defaultOptions: {} });

  return (
    <div className={classes.fullScreen}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <GlobalProvider>
            <Nav />
          </GlobalProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </div>
  );
};

export default App;
